// Mock data for Touricon Consultancy Website

export const companyInfo = {
  name: "TOURICON CONSULTANCY",
  logo: "/logo.png",
  tagline: "Integrated Consultancy for Maldives Resort Purchase, Investing & Construction",
  subTagline: "Strategic, technical, regulatory, and geospatial support — from headlease acquisition and resort purchase to construction and operational readiness.",
  established: 2019,
  about: "Touricon Consultancy, established in 2019, is a specialized consultancy firm supporting Maldives resort purchase, headlease acquisition, and investing, alongside resort development, construction, land reclamation, coastal protection, and pre-opening preparations across the Maldives. With extensive industry expertise and a deep understanding of local regulations and environmental conditions, we support investors, developers, contractors, and resort operators in delivering successful, sustainable, and fully compliant projects. Our mission is to provide end-to-end technical, operational, and geospatial solutions—from island acquisition and headlease transfer to drone mapping and construction management—to ensure projects are executed with precision, efficiency, and excellence."
};

export const services = [
  {
    id: 1,
    title: "Resort Purchase & Development",
    description: "End-to-end support for Maldives resort purchase, headlease acquisition, and investing, through full-cycle resort development to operational readiness.",
    icon: "Building2",
    keyServices: [
      "Maldives Resort & Island Investing Advisory",
      "Island & Lagoon Acquisition Facilitation",
      "Headlease Acquisition & Government Lease Transfer",
      "Ownership & Transfer Consultation",
      "Neutral Transaction Management & Lead Role in Ownership Transfer",
      "Government Permits & Approvals",
      "Compliance Management",
      "Project Coordination",
      "Environmental Impact Assessment (EIA) Support"
    ]
  },
  {
    id: 2,
    title: "Pre-Opening Preparations",
    description: "Comprehensive support to ensure operational readiness before resort launch.",
    icon: "ClipboardCheck",
    keyServices: [
      "Operational standardization aligned with Ministry of Tourism requirements",
      "Compliance audits (safety, hygiene, operational readiness)",
      "Staff readiness & training",
      "Licensing & registration (STP, desalination, F&B outlets, facilities)"
    ]
  },
  {
    id: 3,
    title: "Drone Mapping & Survey",
    description: "Advanced aerial mapping and surveying capabilities for precise project planning.",
    icon: "Plane",
    keyServices: [
      "Orthomosaic mapping for measurement and volume calculations",
      "Aerial data for construction planning and shoreline monitoring",
      "High-resolution photography and videography"
    ]
  },
  {
    id: 4,
    title: "Progress Tracking",
    description: "Real-time project monitoring and comprehensive reporting solutions.",
    icon: "BarChart3",
    keyServices: [
      "Drone-based progress mapping",
      "360° site walkthroughs",
      "Structured reporting for stakeholders"
    ]
  },
  {
    id: 5,
    title: "Coastal Protection",
    description: "Sustainable coastal engineering solutions for long-term shoreline preservation.",
    icon: "Waves",
    keyServices: [
      "Seawalls, revetments, and breakwaters",
      "Erosion control and shoreline stabilization",
      "Long-term coastal resilience consulting"
    ]
  },
  {
    id: 6,
    title: "Reclamation",
    description: "End-to-end land reclamation planning and execution services.",
    icon: "Landmark",
    keyServices: [
      "Concept-to-completion reclamation planning",
      "Stability, sustainability & compliance assurance",
      "Geotechnical and environmental assessments"
    ]
  },
  {
    id: 7,
    title: "Harbour Dredging & Channel Works",
    description: "Professional dredging services for maritime infrastructure development.",
    icon: "Anchor",
    keyServices: [
      "Harbour deepening and basin preparation",
      "Channel development for vessel access",
      "Environmental impact and turbidity monitoring"
    ]
  },
  {
    id: 8,
    title: "Construction Services",
    description: "Full-spectrum construction management for resort and infrastructure projects.",
    icon: "HardHat",
    keyServices: [
      "High-end resort development",
      "Residential & commercial buildings",
      "Infrastructure and utilities development"
    ]
  }
];

export const values = [
  {
    id: 1,
    title: "Excellence",
    description: "Highest service standards in everything we do",
    icon: "Award"
  },
  {
    id: 2,
    title: "Integrity",
    description: "Transparency & professionalism in all dealings",
    icon: "Shield"
  },
  {
    id: 3,
    title: "Innovation",
    description: "Advanced technologies & modern methods",
    icon: "Lightbulb"
  },
  {
    id: 4,
    title: "Sustainability",
    description: "Environmentally responsible development",
    icon: "Leaf"
  }
];

export const contactInfo = {
  address: "G. Dhanbukokaa, Neeloafaru Hingun, 20131, Male', Maldives",
  phones: ["+960 7772830", "+960 7795857", "+960 7776613"],
  emails: ["adly@touriconsult.com", "mohamed@touriconsult.com", "gafoor@touriconsult.com"]
};

export const navItems = [
  { id: "home", label: "Home" },
  { id: "services", label: "Services" },
  { id: "contact", label: "Contact Us" }
];
